"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Marquee = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _styledSystem = require("styled-system");
var _Flex = require("../Flex");
var _Box = require("../Box");
var _Text = require("../Text");
var _excluded = ["marqueeText", "divider", "speed", "color"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var VARIANTS = {
  defaultLight: {
    backgroundColor: "black10",
    color: "black100"
  },
  defaultDark: {
    backgroundColor: "black10",
    color: "black100"
  },
  brand: {
    backgroundColor: "black10",
    color: "black100"
  }
};
var move = function move(props) {
  return (0, _styledComponents.keyframes)(["from{transform:translateX(0);}to{transform:translateX(-", "px);}"], props.offset);
};
var Container = (0, _styledComponents.default)(_Box.Box).withConfig({
  displayName: "Marquee__Container",
  componentId: "sc-7cbzx0-0"
})(["", " width:100%;overflow-x:hidden;"], (0, _styledSystem.variant)({
  variants: VARIANTS
}));
var StyledText = (0, _styledComponents.default)(_Text.Text).withConfig({
  displayName: "Marquee__StyledText",
  componentId: "sc-7cbzx0-1"
})(["", " white-space:nowrap;"], (0, _styledSystem.variant)({
  variants: VARIANTS
}));
var Inner = _styledComponents.default.div.withConfig({
  displayName: "Marquee__Inner",
  componentId: "sc-7cbzx0-2"
})(["animation:", " ", " infinite linear;cursor:default;user-select:none;white-space:nowrap;"], move, function (props) {
  return props.speed;
});
var Item = _styledComponents.default.div.withConfig({
  displayName: "Marquee__Item",
  componentId: "sc-7cbzx0-3"
})(["display:inline-block;"]);
var Marquee = function Marquee(_ref) {
  var marqueeText = _ref.marqueeText,
    _ref$divider = _ref.divider,
    divider = _ref$divider === void 0 ? true : _ref$divider,
    _ref$speed = _ref.speed,
    speed = _ref$speed === void 0 ? "10s" : _ref$speed,
    color = _ref.color,
    rest = _objectWithoutProperties(_ref, _excluded);
  var containerEl = (0, _react.useRef)(null);
  var childEl = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(1),
    _useState2 = _slicedToArray(_useState, 2),
    amount = _useState2[0],
    setAmount = _useState2[1];
  var _useState3 = (0, _react.useState)(0),
    _useState4 = _slicedToArray(_useState3, 2),
    offset = _useState4[0],
    setOffset = _useState4[1];
  (0, _react.useEffect)(function () {
    if (!childEl.current || !containerEl.current) {
      return;
    }
    var containerWidth = containerEl.current.getBoundingClientRect().width;
    var childWidth = childEl.current.getBoundingClientRect().width;
    var targetAmount = Math.min(Math.ceil(containerWidth / childWidth), 100);
    setOffset(targetAmount * childWidth);
    setAmount(Math.ceil(targetAmount * 2));
  }, []);
  return /*#__PURE__*/_react.default.createElement(Container, _extends({
    ref: containerEl,
    backgroundColor: color
  }, rest), /*#__PURE__*/_react.default.createElement(Inner, {
    speed: speed,
    offset: offset
  }, Array.from(Array(amount)).map(function (_, i) {
    return /*#__PURE__*/_react.default.createElement(Item, {
      key: i,
      ref: childEl
    }, /*#__PURE__*/_react.default.createElement(_Flex.Flex, null, /*#__PURE__*/_react.default.createElement(StyledText, {
      px: [2, 4],
      py: 0.5,
      variant: "xs"
    }, marqueeText), divider && /*#__PURE__*/_react.default.createElement(StyledText, {
      px: [1, 4],
      py: 0.5,
      variant: "xs"
    }, "\u2022")));
  })));
};
exports.Marquee = Marquee;
Marquee.displayName = "Marquee";
Marquee.defaultProps = {
  variant: "defaultDark"
};
//# sourceMappingURL=Marquee.js.map